import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@/components/ThemeProvider";
import { Button } from "@/components/ui/button";
import logoDark from "@/assets/newlogo-dark.png";
import logoLight from "@/assets/newlogo-light.png";

interface PublicHeaderProps {
  onToggleSidebar: () => void;
  isSidebarOpen: boolean;
}

export const PublicHeader: React.FC<PublicHeaderProps> = ({
  onToggleSidebar,
  isSidebarOpen,
}) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const logo = theme === "light" ? logoLight : logoDark;

  return (
    <header className="sticky top-0 z-40 bg-background/80 backdrop-blur transition-all">
      <div className="mx-auto px-2 lg:px-4">
        {/* Desktop */}
        <div className="hidden py-2 lg:flex items-center justify-between">
          <div className="flex items-center gap-2">
            {!isSidebarOpen && (
              <div className="flex items-center">
                <button
                  type="button"
                  onClick={onToggleSidebar}
                  className="flex h-8 w-8 items-center justify-center rounded-xl hover:bg-muted transition"
                  aria-label="Toggle sidebar"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 6h16" />
                    <path d="M4 12h16" />
                    <path d="M4 18h16" />
                  </svg>
                </button>
                <a href="/">
                  <img src={logo} className="ml-2 h-10 w-auto cursor-pointer" alt="Shattara AI" />
                </a>
              </div>
            )}
          </div>
          <Button onClick={() => navigate("/auth/signup")} className="h-10 px-6 text-sm font-medium">
            Try It Yourself
          </Button>
        </div>

        {/* Mobile */}
        <div className="flex items-center justify-between py-2 lg:hidden">
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onToggleSidebar}
              className="flex h-9 w-9 items-center justify-center rounded-xl hover:bg-muted transition"
              aria-label="Toggle sidebar"
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
                <path d="M4 6h16" />
                <path d="M4 12h16" />
                <path d="M4 18h16" />
              </svg>
            </button>
            <a href="/">
              <img src={logo} className="h-10 w-auto cursor-pointer" alt="Shattara AI" />
            </a>
          </div>
          <Button onClick={() => navigate("/auth/signup")} size="sm" className="h-9 text-xs font-medium">
            Try It Yourself
          </Button>
        </div>
      </div>
    </header>
  );
};
